/* 太史慈傳・第 2 章：涇縣・丹楊太守（興平二年～建安元年，195–196）
 * 史實：《三國志·太史慈傳》「慈當與繇俱奔豫章，而遁於蕪湖，亡入山中，稱丹楊太守。是時，策已平定宣城以東，惟涇以西六縣未服。
 *       慈因進住涇縣，立屯府，大為山越所附。策躬自攻討，遂見囚執。策即解縛，捉其手曰：『寧識神亭時邪？若卿爾時得我云何？』
 *       慈曰：『未可量也。』策大笑曰：『今日之事，當與卿共之。』」
 * 流程：1. 山越所附：東寨要打退傷人的虎、西寨要看射藝（切成弓，站在射線後射倒三個「的」）、東南寨要護送家眷回屯府；
 *          每寨歸附就有山越壯丁來守屯府。
 *       2. 策躬自攻討：孫軍分路來攻，屯府的守備值在孫軍逼近時往下掉；太史慈要把屯府裡的山越家眷帶到西南的山口送進深山。
 *       3. 遂見囚執：孫策親自上陣。太史慈被壓到殘血（或撐過一段時間）就被擒——劇情，不是失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, rout, TROOPS } from '../kit.ts';
import { TSC_TROOPS, target } from './taishici_kit.ts';
import { FU, EAST, WEST, SOUTH, PASS, ENTRIES, SHOOT, TARGETS } from '../maps/taishici_jingxian.ts';

const LV = 9, FAMS = 8, WAVE = 18, DUEL = 50;
const SUNJUN = { spec: TROOPS.wu, name: '孫軍', hp: 520, maxHp: 520, atk: 24 };

export default {
  id: 'taishici-2', map: 'taishici_jingxian', hero: 'taishici',
  title: '第 2 章　涇縣・丹楊太守', year: '興平二年（195）',
  brief: {
    quote: [
      { text: '慈當與繇俱奔豫章，而遁於蕪湖，亡入山中，稱丹楊太守。', src: '《三國志·吳書·太史慈傳》' },
      { text: '是時，策已平定宣城以東，惟涇以西六縣未服。慈因進住涇縣，立屯府，大為山越所附。', src: '《太史慈傳》' },
    ],
    text: '神亭一戰之後，劉繇兵敗，逃往豫章。太史慈沒有跟去，獨自逃進山裡，自稱丹楊太守，在涇縣立了屯府。孫策這時已經平定宣城以東，只剩涇縣以西六縣還沒歸服。',
    goals: ['得到三處山越寨的歸附', '孫策來攻：把山越家眷送進深山', '（劇情）遂見囚執'],
  },
  words: { ally: '山越', foe: '孫軍' },
  stars: [
    { text: '山越家眷一個都沒死', ok: (m) => m.vars.famDead === 0 },
    { text: '屯府守備沒低於五成', ok: (m) => m.vars.fuMin >= 50 },
    { text: '未可量也：被擒前把孫策打到半血以下', ok: (m) => m.vars.ceMin <= 0.5 },
  ],
  steps: [
    { // 0. 山越所附
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = FU[0] + 150; me.y = FU[1] + 80;
        V.won = 0; V.fu = 100; V.fuMin = 100; V.famDead = 0; V.ceMin = 1; V.braves = [];
        m.card('劉繇以「我若用子義，許子將不當笑我邪」為由不肯重用太史慈，只派他偵視輕重；神亭與孫策遇，「策刺慈馬，而攬得慈項上手戟，慈亦得策兜鍪」（見孫吳傳・神亭酣鬥）。', '《太史慈傳》');
        // 東寨：寨外有虎
        V.tigers = [[EAST[0] - 300, EAST[1] + 350, 2600], [EAST[0] + 250, EAST[1] + 420, 1600]].map(([x, y, hp]) => m.foe('bandit', x, y, { beast: 'tiger', spec: { id: 'tiger', name: '虎', fx: '#ffb040' }, name: '虎', hp, maxHp: hp, atk: 48, ms: 270, r: 30 }));
        // 西寨：射藝
        V.targets = TARGETS.map(([x, y]) => { const u = m.foe('huangjin', x, y, { spec: TSC_TROOPS.shanyue, name: '的', hp: 380, maxHp: 380, atk: 0, armor: 0, ms: 0, gold: 0, xp: 0, untargetable: true }); u.mark = m.folk(x + 50, y + 10, { name: '的', still: true, near: 1, draw: target }); return u; });
        V.shot = 0;
        // 東南寨：家眷要護送
        V.southFam = [];
        V.zhai = [
          { id: 'east', x: EAST[0], y: EAST[1], name: '東寨', say: '寨外有虎，傷了好幾個人。你若能除了牠，我們就跟你。' },
          { id: 'west', x: WEST[0], y: WEST[1], name: '西寨', say: '聽說太守善射？射倒那三個「的」給我們看看——要用弓，站在射線後面。' },
          { id: 'south', x: SOUTH[0], y: SOUTH[1], name: '東南寨', say: '我們願意依附太守。只是老弱走不快，請太守護送他們到屯府。' },
        ];
        for (const Z of V.zhai) {
          Z.chief = m.folk(Z.x, Z.y + 60, { name: `山越宗帥（${Z.name}）`, still: true, near: 220, lines: [[`山越宗帥（${Z.name}）`, Z.say]], onHeard: () => { Z.heard = true; } });
          m.mark(Z.id, Z.x, Z.y, Z.name, true);
        }
        m.line('太史慈', '此去豫章，不如就在這山中立足。');
        m.after(4, () => m.line('提示', '三處山越寨各有一位宗帥，去聽聽他們要什麼。歸附的寨子會派壯丁來守屯府。'));
        m.obj('zhai', '得到山越寨的歸附', 3);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        const done = (Z, text) => {
          Z.done = true; V.won++; m.unmark(Z.id); m.prog('zhai', V.won);
          m.line(`山越宗帥（${Z.name}）`, text);
          for (let i = 0; i < 4; i++) { const u = m.recruit(Z.x + (i - 1.5) * 60, Z.y + 120, '山越壯丁'); Object.assign(u, { spec: TSC_TROOPS.shanyue, hp: 700, maxHp: 700, atk: 26, home: [FU[0] - 250 + (V.braves.length % 6) * 100, FU[1] - 200 + Math.floor(V.braves.length / 6) * 380] }); V.braves.push(u); }
        };
        for (const Z of V.zhai) {
          if (Z.done || !Z.heard) continue;
          if (Z.id === 'east' && V.tigers.every((u) => !u.alive)) done(Z, '好！除了虎患，東寨歸太守了。');
          if (Z.id === 'west') {
            if (!Z.started) { Z.started = true; m.mark('shoot', SHOOT[0], SHOOT[1], '射線', true); }
            const can = me.form === 1 && m.near(me, SHOOT[0], SHOOT[1], 160); // 弓、站在射線後面才算
            for (const u of V.targets) { u.untargetable = !can || !u.alive; if (u.alive) u.target = null; }
            const n = V.targets.filter((u) => !u.alive).length;
            if (n > V.shot) { V.shot = n; m.line('西寨山越', n < 3 ? '中了！' : '三發三中！'); }
            if (n === 3) { m.unmark('shoot'); done(Z, '猿臂善射，名不虛傳。西寨願附。'); }
          }
          if (Z.id === 'south') {
            if (!Z.fam) { Z.fam = true; for (let i = 0; i < 5; i++) { const u = m.recruit(Z.x - 100 + i * 50, Z.y + 160, '山越老弱'); Object.assign(u, { spec: TSC_TROOPS.shanyue, noFight: true }); m.join(u, me); V.southFam.push(u); } m.mark('fu', FU[0], FU[1], '屯府', true); }
            if (V.southFam.every((u) => !u.alive || SG.gd(u.x, u.y, FU[0], FU[1]) < 500) && m.near(me, FU[0], FU[1], 450)) { m.unmark('fu'); for (const u of V.southFam) if (u.alive) { u.owner = null; u.home = [FU[0] + 200, FU[1] + 150]; } done(Z, '老弱都到了。東南寨從此聽太守號令。'); }
          }
        }
        return V.won === 3;
      },
    },
    { // 1. 策躬自攻討：送家眷進山
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('zhai');
        m.card('慈因進住涇縣，立屯府，大為山越所附。', '《太史慈傳》');
        V.fams = Array.from({ length: FAMS }, (_, i) => { const u = m.recruit(FU[0] - 150 + (i % 4) * 80, FU[1] + 120 + Math.floor(i / 4) * 70, '山越家眷'); Object.assign(u, { spec: TSC_TROOPS.shanyue, noFight: true }); return u; });
        for (const u of V.southFam) if (u.alive) { u.alive = false; u.counted = true; } // 東南寨的老弱併進家眷裡
        m.after(3, () => { m.big('孫策親自來攻！'); m.line('斥候', '孫郎的兵從北邊山路下來了！'); });
        m.after(6, () => m.line('提示', '屯府的守備值在孫軍逼近時會往下掉，山越壯丁守著。到屯府帶上家眷，送到西南的山口。'));
        V.waveT = 4; V.wave = 0; V.saved = 0;
        m.obj('fu', '屯府守備：100%');
        m.obj('fam', '把山越家眷送進山口', FAMS);
        m.mark('famHome', FU[0], FU[1] + 160, '家眷');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.waveT -= dt;
        if (V.waveT <= 0) { V.waveT = WAVE; spawnWave(m, V.wave++); }
        if (!V.called) m.chanAt(me, 'call', FU[0], FU[1] + 160, 220, 1.5, '召集家眷', () => { V.called = true; m.unmark('famHome'); m.mark('pass', PASS[0], PASS[1], '山口'); for (const u of V.fams) if (u.alive) m.join(u, me); m.line('太史慈', '老弱跟我走，進山！'); });
        if (V.called) for (const u of V.fams) if (u.alive && !u.safe && SG.gd(u.x, u.y, PASS[0], PASS[1]) < 300) { u.safe = true; V.saved++; u.alive = false; u.counted = true; }
        m.prog('fam', V.saved);
        if (V.called && V.fams.every((u) => !u.alive)) return true;
        return false;
      },
    },
    { // 2. 孫策親至：遂見囚執
      enter(m, w) {
        const V = m.vars;
        m.done('fam'); m.unmark('pass');
        m.line('山越', '家眷都進山了！');
        V.ce = ally(w, 'sunce', ENTRIES[0][0], ENTRIES[0][1] + 300, LV + 3, 1);
        V.ce.maxHp *= 1.8; V.ce.hp = V.ce.maxHp; V.ce.atk *= 1.3; // 孫策親自督戰：比一般的武將耐打
        V.ce.hold = FU.slice();
        V.ceT = w.t;
        m.after(1, () => { m.big('孫策親至'); m.line('孫策', '子義！神亭一別，今日再會！'); });
        m.mark('ce', V.ce.x, V.ce.y, '孫策', false, V.ce);
        m.obj('ce', '迎戰孫策');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, ce = V.ce;
        if (ce.alive) { if (ce.hp < ce.maxHp * 0.3) ce.hp = ce.maxHp * 0.3; V.ceMin = Math.min(V.ceMin, ce.hp / ce.maxHp); } // 孫策不會倒
        return me.hp < me.maxHp * 0.35 || w.t - V.ceT > DUEL;
      },
    },
    { // 3. 被擒，解縛
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('ce'); m.unmark('ce');
        V.caught = true;
        me.untargetable = true; me.input = {};
        w.addBuff(me, { id: '被擒', t: 60, neg: true, ms: -1 });
        m.drop('fu');
        rout(m, w, w.units.filter((u) => u.team === 1 && u !== V.ce), ENTRIES[0]);
        for (const u of V.braves) if (u.alive) { u.home = [PASS[0], PASS[1]]; }
        m.card('策躬自攻討，遂見囚執。', '《太史慈傳》');
        m.after(4, () => m.card('策即解縛，捉其手曰：「寧識神亭時邪？若卿爾時得我云何？」', '《太史慈傳》'));
        m.after(8, () => m.line('太史慈', '未可量也。'));
        m.after(10.5, () => m.card('策大笑曰：「今日之事，當與卿共之。」', '《太史慈傳》'));
        m.after(15, () => m.card('即署門下督，還吳授兵，拜折衝中郎將。後劉繇亡於豫章，士眾萬餘人未有所附，策命慈往撫安焉。「何時能還？」答曰：「不過六十日。」果如期而反（見孫吳傳・如期而返）。', '《太史慈傳》'));
        m.after(20, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('太史慈戰死'); return; }
    if (V.caught) { me.hp = Math.max(me.hp, 1); if (V.ce && V.ce.alive) { V.ce.input.target = null; V.ce.input.moveTo = null; } return; }
    if (V.ce) allyTick(w, V.ce, null, 900);
    if (m.i >= 1 && V.fams) {
      V.famDead = V.fams.filter((u) => !u.alive && !u.safe).length;
      if (V.famDead === FAMS) { m.lose('山越家眷都遇害了'); return; }
      // 屯府守備：孫軍在府前就往下掉，壯丁在府前擋著就掉得慢
      if (m.i === 1) {
        const foes = w.units.filter((u) => u.team === 1 && u.alive && SG.gd(u.x, u.y, FU[0], FU[1]) < 450).length;
        const guards = V.braves.filter((u) => u.alive && SG.gd(u.x, u.y, FU[0], FU[1]) < 500).length;
        V.fu = Math.max(0, V.fu - foes * (guards ? 0.35 : 1) * dt);
        V.fuMin = Math.min(V.fuMin, V.fu);
        const o = m.get('fu'); if (o) o.text = `屯府守備：${Math.ceil(V.fu)}%`;
        if (V.fu <= 0) m.lose('屯府被攻破，家眷還沒送走');
      }
    }
  },
};

// 一波孫軍：從三條路裡挑兩條，往屯府殺過去
function spawnWave(m, k) {
  const roads = [ENTRIES[k % 3], ENTRIES[(k + 1) % 3]];
  for (const [x, y] of roads) for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', x + (i % 3) * 60 - 60, y + Math.floor(i / 3) * 70, SUNJUN); u.home = FU.slice(); }
}
